import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { KeycloakAuthService } from './keycloak-auth.service';
import { QueryParamTokenService } from './query-param-token.service';

export const keycloakAuthGuard: CanActivateFn = async (route, state) => {
  const keycloakAuthService = inject(KeycloakAuthService);
  const queryParamTokenService = inject(QueryParamTokenService);
  const router = inject(Router);

  const urlToken = route.queryParamMap.get('token')?.trim();
  if (urlToken) {
    queryParamTokenService.setToken(urlToken);
    const cleanUrlTree = router.parseUrl(state.url);
    delete cleanUrlTree.queryParams['token'];
    await router.navigateByUrl(cleanUrlTree, { replaceUrl: true });
    return false;
  }

  const isAuthenticated = await keycloakAuthService.ensureAuthenticated(state.url);
  if (!isAuthenticated) {
    return false;
  }

  const isApiAuthorised = await keycloakAuthService.isApiAuthorised();
  if (isApiAuthorised) {
    return true;
  }

  return router.createUrlTree(['/no-access']);
};